module.exports = __webpack_public_path__ + "img/lb.c0fa65db.svg";